import GppBadOutlinedIcon from "@mui/icons-material/GppBadOutlined";
import { formatCentsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import { Text } from "@src/lib/ui-react";

import { Caption, iconSx, RateAdvisoryCard } from "./RateAdvisoryCard";

export const SPEND_LIMIT_EXCEEDED_CARD_TEST_ID = "spend-limit-exceeded-card";
export const REQUEST_LIMIT_INCREASE_BUTTON_TEST_ID = "request-limit-increase-button";

interface RateBoostLimitCardProps {
  overageInMinorUnits: number;
  onRequestIncrease?: () => void;
  isRequested?: boolean;
  /** Optional week range (e.g. "Jan 7, 2026 - Jan 13, 2026") named in the caption when the boost
   * applies across multiple weeks, so the user knows which week is over. */
  weekRange?: string;
}

/** Replaces `FillGuaranteeCard` for a qualification whose chosen rate would push the week over its limit. */
export function RateBoostLimitCard({
  overageInMinorUnits,
  onRequestIncrease,
  isRequested = false,
  weekRange,
}: RateBoostLimitCardProps) {
  const overageDisplay = formatCentsAsUsd(Math.max(0, overageInMinorUnits));
  const caption = weekRange
    ? `This rate would cause rate boost spend to exceed your weekly limit for ${weekRange} by ${overageDisplay}.`
    : `This rate would cause rate boost spend to exceed your weekly limit by ${overageDisplay}.`;

  return (
    <RateAdvisoryCard
      isDisabled
      testId={SPEND_LIMIT_EXCEEDED_CARD_TEST_ID}
      icon={<GppBadOutlinedIcon sx={iconSx(true)} fontSize="small" />}
      title={<Text variant="subtitle2">Rate boost exceeds limit</Text>}
      caption={<Caption color="error">{caption}</Caption>}
      errorAction={
        onRequestIncrease
          ? {
              label: isRequested ? "Increase requested" : "Request increase",
              testId: REQUEST_LIMIT_INCREASE_BUTTON_TEST_ID,
              disabled: isRequested,
              onClick: onRequestIncrease,
            }
          : undefined
      }
    />
  );
}
